import { GameManager } from './../../managers/GameManager';
import { GameConstants } from "../../GameConstants";
import { Button } from "../../utils/Button";
import { GameVars } from "../../GameVars";
import { AudioManager } from '../../managers/AudioManager';
import { BananaSpine } from './banana/BananaSpine';

export class WinnerLayer extends Phaser.GameObjects.Container {

    private confetti: Phaser.GameObjects.Sprite;

    constructor(scene: Phaser.Scene) {

        super(scene);

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x000000, .9);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        background.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        background.on("pointerdown", () => { 
            // 
        });
        this.add(background);

        this.addCredits();

        const backButton = new Button(this.scene, 35 * GameVars.scaleX, 35, "texture_atlas_1", "btn_close.png", "btn_close.png", true, true, .8);
        backButton.onUp(this.onClickBack, this);
        this.add(backButton); 

        const midContainer = new Phaser.GameObjects.Container(this.scene);
        midContainer.setPosition(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        midContainer.scaleX = GameVars.scaleX;
        this.add(midContainer);

        this.confetti = this.scene.add.sprite(0, -20, "texture_atlas_1", "confetti_01.png");
        midContainer.add(this.confetti);

        this.confetti.on("animationcomplete", () => {
            this.confetti.visible = false;
        }, this);

        const wreath = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "winner_wreath.png");
        wreath.setScale(1.6);
        midContainer.add(wreath);

        let id = GameVars.gameState.players[0].id;

        if (id === GameVars.playerId) {
            const titleLabel = new Phaser.GameObjects.Image(this.scene, 0, -150, "texture_atlas_1", "you_win_hilo.png");
            midContainer.add(titleLabel);

            const banana = new BananaSpine(this.scene);
            banana.setPosition(-90, -160);
            banana.setScale(.8);
            banana.setAvatarState("victory2");
            midContainer.add(banana);
        } else {
            const titleLabel = new Phaser.GameObjects.Image(this.scene, 0, -150, "texture_atlas_1", "name_big_" + id + ".png");
            titleLabel.setOrigin(1, .5);
            midContainer.add(titleLabel);

            const titleLabel2 = new Phaser.GameObjects.Text(this.scene, 0, -150, "WINS THE GAME", {fontFamily: "Oswald-Medium", fontSize: "40px", color: "#ffffff"});
            titleLabel2.setOrigin(0, .5);
            midContainer.add(titleLabel2);

            const playerImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "char_win_" + id + ".png");
            midContainer.add(playerImage);

            const banana = new BananaSpine(this.scene);
            banana.setPosition(180, -80);
            banana.setScale(.8);
            banana.setAvatarState("victory2");
            midContainer.add(banana);
        }

        const playButtonContainer = new Phaser.GameObjects.Container(this.scene, 0, 165);
        midContainer.add(playButtonContainer);

        const playButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_yellow.png", "btn_yellow.png", true);
        playButton.onUp(this.onClickPlay, this);
        playButtonContainer.add(playButton);

        const playButtonLabel = new Phaser.GameObjects.Text(this.scene, 0, -15, "PLAY NOW", {fontFamily: "Oswald-Medium", fontSize: "24px", color: "#622F20", align: "center"});
        playButtonLabel.setOrigin(.5);
        playButtonContainer.add(playButtonLabel); 

        const roomPriceLabel = new Phaser.GameObjects.Text(this.scene, - 10, 14, GameVars.formatNumber(GameConstants.ROOM_PRICE), {fontFamily: "Oswald-Medium", fontSize: "22px", color: "#622F20", align: "center"});
        roomPriceLabel.setOrigin(.5);
        playButtonContainer.add(roomPriceLabel); 

        const chipIcon = new Phaser.GameObjects.Image(this.scene, 36, 14, "texture_atlas_1", "chip_pot_icon.png");
        chipIcon.setScale(.9);
        playButtonContainer.add(chipIcon);

        const hiLoButton = new Button(this.scene, 0, 250,  "texture_atlas_1", "btn_hi-lo.png", "btn_hi-lo.png", true);
        hiLoButton.onUp(this.onClickHighLow, this);
        midContainer.add(hiLoButton);

        if (GameVars.gameData.chips < GameConstants.ROOM_PRICE) {

            playButtonContainer.alpha = .5;
            playButton.input.enabled = false;

            this.scene.tweens.add({
                targets: hiLoButton,
                scaleX: 1.05,
                scaleY: .95,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 320,
                repeat: -1,
                yoyo: true
            });
        }

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            onComplete: () => {
                this.confetti.visible = true;
                this.confetti.anims.play("confetti", true);
                AudioManager.playSound("confetti");
            },
            onCompleteScope: this
        });

        AudioManager.volumeMusic(.1);
    }

    private addCredits(): void {

        const creditsContainer = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, 35);
        creditsContainer.setScale(GameVars.scaleX * .8, .8);
        this.add(creditsContainer);

        const w = 220;

        const creditsLabel = new Phaser.GameObjects.Text(this.scene, w / 2 - 60, -2, GameVars.formatNumber(GameVars.gameData.chips), {fontFamily: "Oswald-Medium", fontSize: "46px", color: "#ffffff"});
        creditsLabel.setOrigin(1, .5);
        creditsContainer.add(creditsLabel);

        const chipIconCreditsLabel = new Phaser.GameObjects.Image(this.scene, w / 2 - 30, 0, "texture_atlas_1", "chip_pot_icon.png");
        chipIconCreditsLabel.setScale(1.2 * GameVars.scaleX, 1.2);
        creditsContainer.add(chipIconCreditsLabel);
    }

    private onClickBack(): void {

        AudioManager.playSound("btn_click");
        GameManager.enterSplashScene();

        AudioManager.volumeMusic(.5);
    }

    private onClickPlay(): void {

        AudioManager.playSound("btn_click");

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
                GameVars.typeAd = "Enter Room Scene";
            } else {
                GameManager.enterRoomScene();
            }
        } else {
            GameManager.enterRoomScene();
        }

        AudioManager.volumeMusic(.5);
    }

    private onClickHighLow(): void {

        AudioManager.playSound("btn_click");
        
        if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
                GameVars.typeAd = "Enter HiLo";
            } else {
                GameManager.enterHiLoScene();
            }
        } else {
            GameManager.enterHiLoScene();
        }

        AudioManager.volumeMusic(.5);
    }
}
